/**
 * @generated SignedSource<<4c53bbf07f6d194563ad5dd741c6bde6>>
 * @relayHash 0ff83bfda0775b0ad6b2fa4e475845cc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3fd90da39bf047237dd300707028b9e0597c4037a86a07a3a0a488fc61045e69

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardQuery } from './src_jiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "3fd90da39bf047237dd300707028b9e0597c4037a86a07a3a0a488fc61045e69",
    "metadata": {},
    "name": "src_jiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
